var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolidShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    fill: "none",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.745 6.912c-.335-.335-.838-.503-1.341-.335-3.69.839-7.38 0-10.398-2.18-.503-.336-1.342-.336-1.845 0-3.186 2.18-6.876 3.019-10.565 2.18-.839-.168-1.845.503-2.013 1.342v12.913c0 4.864 2.348 9.392 6.373 12.243l6.205 4.36c.503.336 1.342.336 2.013 0l6.205-4.36c4.025-2.851 6.373-7.38 6.373-12.243V8.254c-.336-.503-.503-1.006-1.007-1.342zm-9.391 15.765h-1.677v1.677c0 1.006-.671 1.677-1.677 1.677-1.007 0-1.677-.67-1.677-1.677v-1.677h-1.678c-1.006 0-1.677-.67-1.677-1.677 0-1.006.671-1.677 1.677-1.677h1.678v-1.677c0-1.006.67-1.677 1.677-1.677 1.006 0 1.677.67 1.677 1.677v1.677h1.677c1.006 0 1.677.67 1.677 1.677 0 1.006-.67 1.677-1.677 1.677z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidShield);
export default __webpack_public_path__ + "static/media/solid_shield.4551e82d47c4da6b7492693ae25d4284.svg";
export { ForwardRef as ReactComponent };